<template>
  <v-card v-if="!declineMode">
    <v-card-title style="background-color: #004056" class="white--text">
      <slot name="openLabel">Claim this Lead!</slot>
    </v-card-title>

    <v-divider />

    <v-card-text class="mt-4">
      <div class="d-flex" style="font-size: 16px">
        <div class="d-flex flex-column black--text">
          <div class="font-weight-bold" style="font-size: 20px">{{ lead.service }}</div>
          <div>{{ lead.friendly_structure_type }}</div>
        </div>
        <div class="ml-auto">
          <strong>{{ $formatters.formatDate(lead.lead_date) }}</strong>
        </div>
      </div>

      <slot />
    </v-card-text>

    <v-divider />

    <v-card-actions class="justify-center py-3 px-6">
      <v-btn @click="declineMode = true">Decline</v-btn>
      <v-btn @click="$emit('close')">Maybe Later</v-btn>
    </v-card-actions>
  </v-card>

  <DeclineLeadCard v-else :lead="lead" @back="declineMode=false" />
</template>

<script>
import DeclineLeadCard from './DeclineLeadCard.vue'

export default {
  name: 'UnopenedLeadCard',

  components: { DeclineLeadCard },

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    declineMode: false,
  }),
}
</script>